import React from "react";
import {filterSessions, isPaperSession, isSpecialSession} from "../commons";
import {BreakSession} from "./BreakSession";
import {deleteSession} from "../api";
import EditSessionModal from "./modals/EditSessionModal";
import AddSessionModal from "./modals/AddSessionModal";
import {SpecialSession} from "./SpecialSession";
import {DeleteModal} from "./modals/DeleteModal";
import {BasicPaperSession} from "./BasicPaperSession";
import {ShowSessionModal} from "./modals/SessionModal";
import {connect} from "react-redux";

class BreakSessionsBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            style: {
                display: ""
            }   // Shows or hides panel blocks
        };

        this.collapsePanel = this.collapsePanel.bind(this);
    }

    collapsePanel() {
        this.setState((state, props) => {
            const style = {};
            if (!state.style.display) {
                style.display = "none";
            } else {
                style.display = "";
            }

            return {style}
        })
    }

    render() {
        const {style} = this.state;
        const breakBlocks = this.props.breakBlocks.map((breakBlock, index) =>
            <BreakSession key={index} session={breakBlock}/>);

        return (
            <div className="panel panel-danger" id="breaks">
                <div className="panel-heading" id="breaksheader">
                    <span className="pull-right glyphicon glyphicon-minus pointer toggleleftpanel"
                          aria-hidden="true"
                          data-toggle='tooltip'
                          data-placement='top'
                          title='Show/Hide blocks'
                          onClick={this.collapsePanel}>
                    </span>
                    <div>
                        <span data-toggle='tooltip' data-placement='top'
                              title='This panel contains break blocks, such as lunch and dinner breaks'>
                            <b>Break blocks</b>
                        </span>
                    </div>
                </div>

                <div className="container-fluid panelcontent" id="breakscontent" style={style}>
                    {breakBlocks}
                </div>
            </div>
        )
    }
}

class SpecialSessionsBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            style: {
                display: ""
            },      // Shows or hides panel blocks
            showModal: {
                Add: false,
                Edit: false,
                Delete: false,
            },          // Controls whether to show modal window
            editSessionId: null
        };

        this.collapsePanel = this.collapsePanel.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    collapsePanel() {
        this.setState((state, props) => {
            const style = {};
            if (!state.style.display) {
                style.display = "none";
            } else {
                style.display = "";
            }

            return {style}
        })
    }

    showModal(modalName, sessionId) {
        this.setState((state, props) => {
            let {showModal, editSessionId} = {...state};

            showModal[modalName] = true;
            editSessionId = sessionId ? sessionId : null;

            return {showModal, editSessionId}
        })
    }

    closeModal(modalName) {
        this.setState((state, props) => {
            const {showModal} = {...state};
            showModal[modalName] = false;
            return {showModal}
        })
    }

    handleRemoveSessionClick(sessionId, event) {
        const callback = () => {
            /* If session has been deleted correctly from the server side
then remove it from the session list */
            this.props.removeSession(sessionId);

            this.closeModal("Delete");
        };

        deleteSession(sessionId, this.props.user.api_token, callback)
    }

    render() {
        const {style, editSessionId} = this.state;
        const {sessions} = this.props;

        /* Create a modal window component for editing a session */
        let editSessionModal;
        if (this.state.showModal.Edit) {
            const session = sessions[editSessionId];
            editSessionModal =
                <EditSessionModal show={this.state.showModal.Edit}
                                  title={"Edit " + session.type + " Session"}
                                  session={session}
                                  handleClose={(e) => this.closeModal("Edit")}
                                  sessionTypes={this.props.sessionTypes}
                                  selectedSessionType={session.type}
                                  user={this.props.user}/>
        }


        return (
            <div className="panel panel-warning" id="specialsession">
                <div className="panel-heading" id="specialsessionheader">
                    <span className="pull-right glyphicon glyphicon-minus pointer toggleleftpanel"
                          title='Show/Hide blocks'
                          aria-hidden="true"
                          onClick={this.collapsePanel}>
                    </span>
                    <a title="Create new special session"
                       className="openmodal-specialsession pull-right pointer"
                       onClick={(e) => this.showModal("Add")}>
                        Add New...
                    </a>
                    <AddSessionModal show={this.state.showModal.Add}
                                     title="Add New Special Session"
                                     handleClose={(e) => this.closeModal("Add")}
                                     onSessionSaved={() => {
                                     }}
                                     sessionTypes={this.props.sessionTypes}
                                     forceTypeSelection={true}
                                     user={this.props.user}/>
                    {editSessionModal}
                    <div>
                        <span data-toggle='tooltip'
                              data-placement='top'
                              title='This panel contains special sessions (keynotes, invited talks, ...)'>
                            <b>Special Session blocks</b>
                        </span>
                    </div>
                </div>

                <div className="container-fluid panelcontent" id="specialsessioncontent" style={style}>
                    {Object.values(sessions).map((session) => <SpecialSession key={session.id}
                                                                              session={session}
                                                                              handleRemoveClick={(e) => this.showModal("Delete", session.id)}
                                                                              showModal={(e) => this.showModal("Edit", session.id)}/>)}
                </div>

                {/* Delete modal window */}
                {this.state.showModal.Delete &&
                <DeleteModal show={this.state.showModal.Delete}
                             handleClose={(e) => this.closeModal("Delete")}
                             handleDeleteClick={(e) => this.handleRemoveSessionClick(editSessionId, e)}/>}

            </div>
        )
    }
}

class PaperSessionsBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            style: {
                display: ""
            },  // Shows or hides panel blocks
            showModal: false,
            sessionIdToShow: null
        };

        this.collapsePanel = this.collapsePanel.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    collapsePanel() {
        this.setState((state, props) => {
            const style = {};
            if (!state.style.display) {
                style.display = "none";
            } else {
                style.display = "";
            }

            return {style}
        })
    }

    /* Opens up a modal window */
    showModal(sessionId) {
        this.setState((state, props) => {
            return {showModal: true, sessionIdToShow: sessionId};
        });
    }

    /* Closes a modal window */
    closeModal() {
        this.setState((state, props) => {
            return {showModal: false};
        });
    }

    render() {
        const {style} = this.state;
        return (
            <div id="session" className="panel panel-info">
                <div className="panel-heading" id="sessionheader">
                    <span className="pull-right glyphicon glyphicon-minus pointer toggleleftpanel"
                          data-toggle='tooltip'
                          data-placement='top'
                          title='Show/Hide blocks'
                          aria-hidden="true"
                          onClick={this.collapsePanel}>
                    </span>
                    <div>
                        <span data-toggle='tooltip'
                              data-placement='top'
                              title='This panel contains sessions with papers, created in Sessions webpage (see top-right corner)'>
                            <b>Session blocks</b>
                        </span>
                    </div>
                </div>

                <div className="container-fluid panelcontent" id="sessioncontent" style={style}>
                    {Object.values(this.props.sessions).map((paperSession) =>
                        <BasicPaperSession
                            key={paperSession.id}
                            handleShowModal={(e) => this.showModal(paperSession.id)}
                            paperSession={paperSession}/>
                    )}
                </div>
                {this.state.showModal && <ShowSessionModal
                    show={this.state.showModal}
                    handleClose={this.closeModal}
                    session={this.props.sessions[this.state.sessionIdToShow]}/>
                }
            </div>
        )
    }
}

class LeftFrame extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filterText: ''
        };

        this.BREAK_SESSIONS = [
            {type: "Break", data: {"name": "Coffee break"}},
            {type: "Break", data: {"name": "Dinner"}},
            {type: "Break", data: {"name": "Gala dinner"}},
            {type: "Break", data: {"name": "Lunch"}},
            {type: "Break", data: {"name": "Break"}}
        ];

        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(event) {
        this.setState({filterText: event.target.value});
    }

    render() {
        let {filterText} = this.state;
        let {unAssignedSessionIds} = this.props;

        /* Filter sessions by input text and distribute sessions based on their type */
        let unAssignedSessions = unAssignedSessionIds.map((sessionId) => this.props.sessions[sessionId]);
        const specialSessions = {};
        const paperSessions = {};
        filterSessions(filterText, unAssignedSessions).forEach((session, index) => {
            const sessionId = session.id;
            if (isPaperSession(session)) {
                paperSessions[sessionId] = session
            } else if (isSpecialSession(session)) {
                specialSessions[sessionId] = session
            }
        });

        const breakSessions = filterSessions(filterText, this.BREAK_SESSIONS);

        return (
            <div id="left">
                {/*----- LEFT NAVBAR HEADER -----*/}
                <div className="filter">
                    <h4>Blocks</h4>
                    <input type="text"
                           className="form-control"
                           placeholder="Filter by name, keyword or track"
                           value={this.state.filterText}
                           onChange={this.handleOnChange}/>
                </div>


                {/*----- LEFT ALLBLOCKS SECTION -----*/}
                <div id="allblocks" className="scrollable">
                    {/*----- BREAK SESSION BLOCKS -----*/}
                    <BreakSessionsBlock breakBlocks={breakSessions}/>

                    {/*----- SPECIAL SESSION BLOCKS -----*/}
                    <SpecialSessionsBlock sessionTypes={this.props.sessionTypes}
                                          sessions={specialSessions}
                                          removeSession={this.props.removeSession}
                                          user={this.props.user}/>
                    {/*----- PAPER SESSION BLOCKS -----*/}
                    <PaperSessionsBlock sessions={paperSessions}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        unAssignedSessionIds: state.sessions.unAssignedSessionIds
    }
};

export default connect(
    mapStateToProps,
    null
)(LeftFrame);
